import {
  Component,
  OnInit,
  NgZone
} from '@angular/core';
import {
  HelperService
} from '../helper.service';
import {
  UserService
} from '../user.service';
import {
  Router
} from '@angular/router';
import {
  NgxSpinnerService
} from "ngx-spinner";
import {
  NgxImageCompressService
} from 'ngx-image-compress';

import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
    loadStripe() {
     
        if(!window.document.getElementById('stripe-script')) {
          var s = window.document.createElement("script");
          s.id = "stripe-script";
          s.type = "text/javascript";
          s.src = "https://js.stripe.com/v2/";
          s.onload = () => {
            window['Stripe'].setPublishableKey(this.UserService.stripe_key());
          }
          window.document.body.appendChild(s);
        }
      }
  constructor(private helper: HelperService, private router: Router, private UserService: UserService, private SpinnerService: NgxSpinnerService, private imageCompress: NgxImageCompressService, private zone: NgZone) {
      //this.helper.loginRedirect();
      
  }
  buttonLoading = false;
  yearList= [];
  StripeCardEror = '';
  add_card_submitted = false;
  addNewDisabled = true;
  creditSuccessMsg = '';
  creditErrorMsg = '';
  credit_form_submitted = false;
  credit_form_submittedauto = false;
  phoneValue = '';
  validPassword = false;
  validPasswordMsg = '';
  stateLoading = false;
  successMessage = HelperService.successMessage;
  file: any;
  localUrl: any;
  localCompressedURl: any;
  sizeOfOriginalImage: number;
  sizeOFCompressedImage: number;
  loggedInUserName: string = 'User';
  loggedInUserFirstName: string = 'User';
  loggedInUserEmail: string = '';
  productData = [];
  countries = [];
  cites = [];
  spinner = false;
  checkSign = false;
  states = [];
  showNoRecord = false;
  buttonhide = true;
  isValidationError: boolean = false
  ShowLoading = false;
  ShowPayNow = true;
  V_email: string = ''
  topup_amount: string = ''
  topup_card_id: string = ''
  topup_threshold: string = ''
  V_contact: string = '';
  V_firstname: string = '';
  V_lastname: string = '';
  V_address: string = '';
  V_addressOptional: string = '';
  V_Country: number;
  V_State: number;
  V_city: string = '';
  V_zipcode: string = '';
  Profilemessage: string = '';
  Passwdemessage: string = '';
  Cardmessage: string = '';
topup_card_id1: string ='';
  emailError: string = '';
  passwordError: string = '';
  contactError: string = '';
  first_nameError: string = '';
  last_nameError: string = '';
  address_line1Error: string = '';
  address_line2Error: string = '';
  cityError: string = '';
  countryError: string = '';
  stateError: string = '';
  zipError: string = '';
  payment_methodError: string = '';
  card_numberError: string = '';
  card_expiry_dateError: string = '';
  card_expiry_yearError: string = '';
  card_cvvError: string = '';
  cardError: string = '';
  plainText: string;

  phoneUpdate: string = '';
  addressUpdate: string = '';
  nameUpdate: string = '';
  emailUpdate: string = '';
  passwordMessage: string = '';
  OldPassError: string = '';
  newPassError: string = '';
  confirmPassError: string = '';
  profileImageEncode: string = '';
  V_Profile_image: string = '';
  fileToUpload: File = null;
  done = false;
  profileImage: string='';
  profile_imageError: string = '';
  imageUpdate: string = '';
  fileuploadurl = this.UserService.profile_image_url;
  V_credits = '';
  cardList = [];
  V_stripe_id = '';
  ngOnInit(): void {
    this.loadStripe();
      window.scrollTo(0, 0);
      this.SpinnerService.show();

      this.UserService.getYearList().subscribe((data: any) => {
        this.yearList = data;
      });
      if (localStorage.getItem('nu_first_name') !== null) {
          this.loggedInUserFirstName = localStorage.getItem('nu_first_name');
          this.loggedInUserName = localStorage.getItem('nu_first_name');
          this.loggedInUserEmail = localStorage.getItem('nu_email');
          //this.V_email = this.loggedInUserEmail
          this.UserService.GetUserDetails(localStorage.getItem('nu_c_user_id')).subscribe(res => {
             // console.log(res);
              if (res.profile[0]) {


                  //console.log(res.profile[0]);
                  this.topup_amount = res.profile[0].topup_amount;
                  this.topup_card_id = res.profile[0].topup_card_id;
                  this.topup_threshold = res.profile[0].topup_threshold;
				  const topup_card_id1 =  this.topup_card_id;
				  if(topup_card_id1 !='0')
				  {
				    this.purchase_credit_formauto.get('card_id').setValue(topup_card_id1);
				  }
                  this.V_email = res.profile[0].email;
                  this.V_contact = res.profile[0].mobile_no;
                  this.V_firstname = res.profile[0].first_name;
                  this.V_lastname = res.profile[0].last_name;
                  this.V_address = res.profile[0].address;
                  this.V_addressOptional = res.profile[0].address_optional;
                  this.V_Country = res.profile[0].country;
                  this.V_Profile_image = res.profile[0].profile_image;
                  //console.log(this.V_Country);
                  if (res.profile[0].country) {
                      this.UserService.getRegions(this.V_Country).subscribe(res => {
                          this.states = res.regions;
                      })
                  }
                  this.phoneValue = this.V_contact;
                  // this.V_State =res.profile[0].state;
                  this.V_State = res.profile[0].state;
                  this.V_city = res.profile[0].city;
                  this.V_zipcode = res.profile[0].zip;
                  this.V_credits = res.profile[0].credits;
                  this.V_stripe_id = res.profile[0].stripe_id;
                  /* if(this.V_firstname == null || this.V_firstname == ''){
                    const openNameModal = document.querySelector('.edit_name_btn');
                    if (openNameModal instanceof HTMLElement) {
                      openNameModal.click();
                    }
                  }
                  else if(this.V_contact == null || this.V_contact == ''){
                    const openPhoneModal = document.querySelector('.edit_phone_btn');
                    if (openPhoneModal instanceof HTMLElement) {
                        openPhoneModal.click();
                    }
                  }
                  else if(this.V_address == null || this.V_address == ''){
                    const openAddressModal = document.querySelector('.edit_address_btn');
                    if (openAddressModal instanceof HTMLElement) {
                      openAddressModal.click();
                    }
                  } */
                  this.SpinnerService.hide();
              }

          });


          this.UserService.getcountries().subscribe((data: any) => {
              this.countries = data.countries;

          })

          
      }
      this.userCards();
  }

  userCards(){
    this.UserService.getUserCards().subscribe((res => {
		if(res.status == 1){
          this.cardList = res.card;
        }
      }));
  }
  /* emailForm = new FormGroup({
    enterEmail: new FormControl('', [Validators.required, Validators.email]),
  }); */

  /* phoneForm = new FormGroup({
  enterPhone: new FormControl('', [Validators.required, Validators.minLength(10)]),
});
*/
  /* addressForm = new FormGroup({
    enterAddress: new FormControl(''),
    enterCity: new FormControl(this.V_city),
  }); */

  /* get email_f(){
    return this.emailForm.controls;
  } */

  /* get phone_f(){
    if(this.phoneForm.touched && this.phoneForm.invalid){
      this.contactError = '';
    }
    return this.phoneForm.controls;
  } */

  /* get address_f(){
    return this.addressForm.controls;
  } */
  changeState(event) {
      this.stateLoading = true;
      // localStorage.setItem('country.id', event);
      this.UserService.getRegions(event).subscribe(res => {
          this.states = res.regions;
          this.stateLoading = false;
      })

  }
  changeEmail(event) {
      this.SpinnerService.show();
      event.preventDefault();
      const target = event.target;
      const email = target.querySelector("#enterEmail").value;
      const cancelBtn = document.querySelector('#changeEmailPopup .cancelbttn');

      this.UserService.updateCustomerEmail(email).subscribe(
          resp => {
              if (resp.status == 2) {
                  this.SpinnerService.hide();
                  this.emailError = resp.validationErrors.email;
              } else {
                  this.SpinnerService.hide();
                  this.emailError = '';
                  this.emailUpdate = this.successMessage
                  setTimeout(() => {
                        this.emailUpdate = '';
                        const cancelbttn = document.querySelector('.cancelbttn_email');
                        if (cancelbttn instanceof HTMLElement) {
                            cancelbttn.click();
                        }
                    }, 1500)
                  this.V_email = email;
                  localStorage.setItem('nu_email', email);
              }

          }
      );
  }

  changePhone(event) {
      this.SpinnerService.show();
      event.preventDefault();
      ////console.log(this.phoneForm.value);
      const target = event.target;
      const email = this.V_email;
      const mobile_no = target.querySelector("#enterPhone").value.trim();
      const firstname = this.V_firstname;
      const lastname = this.V_lastname;
      const address = this.V_address;
      const address_Optional = this.V_addressOptional;
      const city = this.V_city;
      const country: number = this.V_Country;

      const state: number = this.V_State;
      const zip = this.V_zipcode;
      const cancelBtn = document.querySelector('#changeEmailPopup .cancelbttn');
      this.UserService.updateCustomerMobile(mobile_no).subscribe(
          resp => {
              if (resp.status == 2) {
                  this.SpinnerService.hide();
                  this.contactError = resp.validationErrors.mobile_no;
              } else {
                  this.SpinnerService.hide();
                  this.contactError = '';
                  this.phoneUpdate = this.successMessage
                  setTimeout(() => {
                        this.phoneUpdate = '';
                        const cancelbttn = document.querySelector('.cancelbtn_phone');
                        if (cancelbttn instanceof HTMLElement) {
                            cancelbttn.click();
                        }
                }, 1500)
                  this.V_contact = mobile_no;
              }

          }
      );
  }

  changeAddress(event) {
      this.SpinnerService.show();
      event.preventDefault();
      ////console.log(this.phoneForm.value);
      const target = event.target;
      const email = this.V_email;
      const mobile_no = this.V_contact;
      const firstname = this.V_firstname;
      const lastname = this.V_lastname;
      const address = target.querySelector("#enterAddress").value;
      const address_Optional = this.V_addressOptional;
      const city = target.querySelector("#enterCity").value;
      const country = target.querySelector("#enterCountry").value;

      const state: number = target.querySelector("#enterState").value;
      const state_option = target.querySelector("#enterState");
      const state_name = state_option.options[state_option.selectedIndex].text;
      const zip = target.querySelector("#enterZip").value;
      const cancelBtn = document.querySelector('#changeEmailPopup .cancelbttn');
      // return false;
      this.UserService.updateCustomerAddress(address, city, state, zip, country).subscribe(
          resp => {
              if (resp.status == 2) {
                  this.SpinnerService.hide();
                  this.address_line1Error = resp.validationErrors.address;
                  this.cityError = resp.validationErrors.city;
                  this.zipError = resp.validationErrors.zip;
                  this.stateError = resp.validationErrors.state;
                  this.countryError = resp.validationErrors.country;
              } else {
                  this.SpinnerService.hide();
                  this.address_line1Error = '';
                  this.cityError = '';
                  this.zipError = '';
                  this.stateError = '';
                  this.countryError = '';
                  this.addressUpdate = this.successMessage
                  setTimeout(() => {
                        this.addressUpdate = '';
                        const cancelbttn = document.querySelector('.cancelbttn_address');
                        if (cancelbttn instanceof HTMLElement) {
                            cancelbttn.click();
                        }
                    }, 1500)
                  this.V_address = address;
                  this.V_city = city;
                  this.V_zipcode = zip;
                  this.V_State = state;
              }

          }
      );
  }

  changeName(event) {
      this.SpinnerService.show();
      event.preventDefault();
      ////console.log(this.phoneForm.value);
      const target = event.target;
      const email = this.V_email;
      const mobile_no = this.V_contact;
      const firstname = target.querySelector("#enterFName").value.trim();
      const lastname = target.querySelector("#enterLName").value.trim();
      const address = this.V_address;
      const address_Optional = this.V_addressOptional;
      const city = this.V_city;
      const country: number = this.V_Country;

      const state: number = this.V_State;
      const zip = this.V_zipcode;
      const cancelBtn = document.querySelector('#changeEmailPopup .cancelbttn');
      this.UserService.updateCustomerName(firstname, lastname).subscribe(
          resp => {
              if (resp.status == 2) {
                  this.SpinnerService.hide();
                  this.first_nameError = resp.validationErrors.first_name;
                  this.last_nameError = resp.validationErrors.last_name;
              } else {
                  this.SpinnerService.hide();
                  this.first_nameError = '';
                  this.last_nameError = '';
                  this.nameUpdate = this.successMessage
                  setTimeout(() => this.nameUpdate = '', 2000)
                  this.V_firstname = firstname;
                  this.V_lastname = lastname;
                  localStorage.setItem('nu_first_name', firstname);
                  localStorage.setItem('nu_last_name', lastname);
              }

          }
      );
  }

  updatePassword(event) {
      this.SpinnerService.show();
      this.spinner = true;
      event.preventDefault();
      const target = event.target;
      const oldPass = target.querySelector("#oldPassword").value;
      const newPass = target.querySelector("#Newpassword").value;
      const confirmPass = target.querySelector("#Confirmpassword").value;
      const user_id = localStorage.getItem('nu_c_user_id')
      this.UserService.changeUserPassword(oldPass, newPass, confirmPass, user_id).subscribe(res => {
          if (res.status == 2) {
              this.SpinnerService.hide();
              this.spinner = false;
              this.OldPassError = res.validationErrors.oldPassword;
              this.newPassError = res.validationErrors.newPassword;
              this.confirmPassError = res.validationErrors.confirmPassword;

          } else {
              this.SpinnerService.hide();
              if (res.status == 1) {
                  this.spinner = false;
                  this.done = true;
                  this.passwordMessage = res.message;
                  setTimeout(() => {
                    this.done = false;
                    const cancelbttn = document.querySelector('.cancelbttn_pwd');
                      if (cancelbttn instanceof HTMLElement) {
                          cancelbttn.click();
                      }
                      this.passwordMessage = '';
                }, 1500);
              }
              this.OldPassError = '';
              this.newPassError = '';
              this.confirmPassError = '';
          }


      })


  }

  handleFileInput(event: any) {
    this.profile_imageError = '';
      this.SpinnerService.show();
      var fileName: any;
      this.file = event.target.files[0];
      fileName = this.file['name'];
      if (event.target.files && event.target.files[0]) {
          var reader = new FileReader();
          reader.onload = (event: any) => {
              this.localUrl = event.target.result;
              const compressed_image = this.compressFile(this.localUrl, fileName);
              this.imageCompress.compressFile(this.localUrl, fileName, 50, 50).then(
                  result => {
                      this.SpinnerService.show();
                      this.imgResultAfterCompress = result;
                      this.localCompressedURl = result;
                      this.sizeOFCompressedImage = this.imageCompress.byteCount(result) / (1024 * 1024)
                      console.warn('Size in bytes after compression:', this.sizeOFCompressedImage);
                      document.querySelector('#profile_image_src').setAttribute('src', result);
                      // create file from byte
                      const imageName = fileName;
                      // call method that creates a blob from dataUri
                      const imageBlob = this.dataURItoBlob(this.imgResultAfterCompress.split(',')[1]);
                      //imageFile created below is the new compressed file which can be send to API in form data
                      const imageFile = new File([result], imageName, {
                          type: 'image/jpeg'
                      });
                      this.fileToUpload = imageFile;
                      if (imageFile) {
                          //this.SpinnerService.hide();
                      }
                      setTimeout(() => this.SpinnerService.hide(), 1000);
                  });

              //this.compressFile(this.localUrl,fileName)
          }
      }
      reader.readAsDataURL(event.target.files[0]);
      return false;
      /* this.profile_imageError = '';
      this.fileToUpload = event.item(0);
      var reader = new FileReader();
      var result = '';
      reader.readAsDataURL(this.fileToUpload);
      reader.onload = function () {
        //console.log(reader.result);
        const image_src: string = reader.result as string;
        //const image_src = reader.result;
        document.querySelector('#profile_image_src').setAttribute('src',image_src);

        
      };
      reader.onerror = function (error) {
        //console.log('Error: ', error);
      }; */

  }

  uploadFileToActivity() {
      this.SpinnerService.show();
      //console.log(this.fileToUpload);
      this.profileImageEncode = ( < HTMLImageElement > document.querySelector("#profile_image_src")).src;
      if (this.fileToUpload != null) {
          this.profile_imageError = '';
          this.UserService.postFile(this.profileImageEncode).subscribe(res => {
              if (res.status == 2) {
                  this.SpinnerService.hide();
                  this.profile_imageError = res.validationErrors.profile_image;
              } else {
                  this.SpinnerService.hide();
                  this.V_Profile_image = res.profile_image;
                  localStorage.setItem('nu_profile_image', res.profile_image);
                  document.querySelector('.top_profile_image').setAttribute('src',this.fileuploadurl+res.profile_image);
                  this.profileImage = res.profile_image;
                  this.profile_imageError = '';
                  this.imageUpdate = this.successMessage
                  setTimeout(() => {
                        this.imageUpdate = '';
                        const cancelbttn = document.querySelector('.cancelbttn_profile');
                        if (cancelbttn instanceof HTMLElement) {
                            cancelbttn.click();
                        }
                }, 1500)

              }


          });
      } else {
          this.SpinnerService.hide();
          this.profile_imageError = 'Please select a image file';
      }

  }

  triggerFileUpload() {
      const openFileInput = document.querySelector('#profile_image');
      if (openFileInput instanceof HTMLElement) {
          openFileInput.click();
      }
  }

  imgResultBeforeCompress: string;
  imgResultAfterCompress: string;
  compressFile(image, fileName) {
    this.SpinnerService.show(); 
      var orientation = -1;
      this.sizeOfOriginalImage = this.imageCompress.byteCount(image) / (1024 * 1024);
      console.warn('Size in bytes is now:', this.sizeOfOriginalImage);
      this.imageCompress.compressFile(image, orientation, 50, 50).then(
          result => {
             
              this.imgResultAfterCompress = result;
              this.localCompressedURl = result;
              this.sizeOFCompressedImage = this.imageCompress.byteCount(result) / (1024 * 1024)
              console.warn('Size in bytes after compression:', this.sizeOFCompressedImage);
              // create file from byte
              const imageName = fileName;
              // call method that creates a blob from dataUri
              const imageBlob = this.dataURItoBlob(this.imgResultAfterCompress.split(',')[1]);
              //imageFile created below is the new compressed file which can be send to API in form data
              const imageFile = new File([result], imageName, {
                  type: 'image/jpeg'
              });
              //this.fileToUpload = imageFile;
              /* //console.log(imageFile);
              if(imageFile){
                this.SpinnerService.hide(); 
              }  */

          });
  }
  dataURItoBlob(dataURI) {
      const byteString = window.atob(dataURI);
      const arrayBuffer = new ArrayBuffer(byteString.length);
      const int8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < byteString.length; i++) {
          int8Array[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([int8Array], {
          type: 'image/jpeg'
      });
      return blob;
  }

  enterPassword(event){
	//console.log(event);
	var res;
	var str = event;
	if(event != ''){
		if (str.match( 
				/[0-9]/g) && str.match( 
				/[^a-zA-Z\d]/g) && str.length >= 8) {
			res = "TRUE"; 
			this.validPassword = true;
			this.validPasswordMsg = '';
		}
		else {
			this.validPasswordMsg = 'Password must contain minimum 8 characters, 1 number, 1 alphabet and 1 special character';
			res = "FALSE";
			this.validPassword = false;
		}
	}
	//console.log(res);
  }
  /* enterPhone(phone){
    var phoneFormatted = phone.slice(0, 3) + "-" + phone.slice(3, 6) + "-" + phone.slice(6);
        $(event).val(phoneFormatted)
    } */

  purchase_credit_form = new FormGroup({
    card_id: new FormControl('', [Validators.required]),
    amount: new FormControl('', [Validators.required]),
  });
	purchase_credit_formauto = new FormGroup({
    card_id: new FormControl('', [Validators.required]),
    amounttop1: new FormControl('', [Validators.required]),
    amounttop2: new FormControl('', [Validators.required]),
  });
  
    get purchase_credit_f(){
        return this.purchase_credit_form.controls;
    }
	  get purchase_credit_fauto(){
        return this.purchase_credit_formauto.controls;
    }
  
    purchase_credit_submit(){
        this.creditSuccessMsg ="";
        this.creditErrorMsg ="";
        this.credit_form_submitted = true;
        this.SpinnerService.show();
        const amount = this.purchase_credit_form.value.amount;
        if(this.purchase_credit_form.invalid){
            this.SpinnerService.hide();
            return false;
        }
        const card_id = this.purchase_credit_form.value.card_id;
        
        this.UserService.purchaseCredit(card_id,amount).subscribe(res => {
            this.SpinnerService.hide();
            //console.log(res);
            //this.creditResponseMsg = res.msg;
            if(res.status == '1'){
                this.creditSuccessMsg = res.msg;
                this.creditErrorMsg = "";
                setTimeout(() => {
                    this.ngOnInit();
                    const close_purchase_modal = document.querySelector('.close_purchase_modal');
                    if (close_purchase_modal instanceof HTMLElement) {
                        close_purchase_modal.click();
                    }
                }, 1500);
                ////console.log('success');
            }
            if(res.status == '2'){
                this.creditErrorMsg = res.msg;
                this.creditSuccessMsg = "";
                ////console.log('error');
                
            }
        }) 
    }
	
	purchase_credit_submitauto(){
        this.creditSuccessMsg ="";
        this.creditErrorMsg ="";
        this.credit_form_submittedauto = true;
        this.SpinnerService.show();
        const amounttop1 = this.purchase_credit_formauto.value.amounttop1;
        const amounttop2 = this.purchase_credit_formauto.value.amounttop2;
        if(this.purchase_credit_formauto.invalid){
            this.SpinnerService.hide();
            return false;
        }
        const card_id = this.purchase_credit_formauto.value.card_id;
		
        this.UserService.updatetopup(card_id,amounttop1,amounttop2).subscribe(res => {
            this.SpinnerService.hide();
			//this.creditResponseMsg = res.msg;
            if(res.status == '1'){
                this.creditSuccessMsg = 'Your Auto Topup settings have been saved';
                this.creditErrorMsg = "";
                setTimeout(() => {
                    this.ngOnInit();
                    const close_purchase_modalauto = document.querySelector('.close_purchase_modalauto');
                    if (close_purchase_modalauto instanceof HTMLElement) {
                        close_purchase_modalauto.click();
                    }
                }, 1500);
                ////console.log('success');
            }
            if(res.status == '2'){
                this.creditErrorMsg = res.msg;
                this.creditSuccessMsg = "";
                ////console.log('error');
                
            }
			// this.ngOnInit();
        }) 
    }

    openCreditsModal(){
        this.creditSuccessMsg ="";
        this.creditErrorMsg ="";
        this.credit_form_submitted = false;
    }
	
	 openCreditsModalauto(){
        this.creditSuccessMsg ="";
        this.creditErrorMsg ="";
        this.credit_form_submittedauto = false;
    }
	
    selectCard(){
        this.creditSuccessMsg ="";
        this.creditErrorMsg ="";
    }

    addNewCard(){
        const close_card_mdl = document.querySelector('.close_purchase_modal');
        if (close_card_mdl instanceof HTMLElement) {
          close_card_mdl.click();
        }
      }
	addNewCardauto(){
        const close_card_mdlauto = document.querySelector('.close_purchase_modalauto');
        if (close_card_mdlauto instanceof HTMLElement) {
          close_card_mdlauto.click();
        }
      }
      enterAmount(){
        const amount = this.purchase_credit_form.value.amount;
        //console.log(amount);
        if(amount == '' || !amount){
            this.addNewDisabled = true;
        }
        else{
            this.addNewDisabled = false;
        }
      } 
	
	enterAmountauto(){
        const amounttop1 = this.purchase_credit_formauto.value.amounttop1;
        const amounttop2 = this.purchase_credit_formauto.value.amounttop2;
        //console.log(amount);
        if(amounttop1 == '' || !amounttop1 || amounttop2 == '' || !amounttop2){
            this.addNewDisabled = true;
        }
        else{
            this.addNewDisabled = false;
        }
      } 

      add_card_form = new FormGroup({
        name: new FormControl('', [Validators.required]),
        number: new FormControl('', [Validators.required]),
        exp_month: new FormControl('', [Validators.required]),
        exp_year: new FormControl('', [Validators.required]),
        cvv: new FormControl('', [Validators.required]),
      });
      
      get add_card_f(){
        return this.add_card_form.controls;
      }
      
      add_card_submit(){
        this.buttonLoading = true;
        this.add_card_submitted = true;
        this.SpinnerService.show();
        if(this.add_card_form.invalid){
          this.buttonLoading = false;
          this.SpinnerService.hide();
          return false;
        }
        //console.log(this.add_card_form.value);
        const CardNumber = this.add_card_form.get('number').value.trim();
        const Expirationdate = this.add_card_form.get('exp_month').value;
        const expYear = this.add_card_form.get('exp_year').value;
        const CVV = this.add_card_form.get('cvv').value.trim();
        if (!window['Stripe']) {
          alert('Oops! Stripe did not initialize properly.');
          return;
        }
        (<any>window).Stripe.card.createToken({
          number: CardNumber,
          exp_month: Expirationdate,
          exp_year: expYear,
          cvc: CVV,
        }, (status: number, response: any) => {
            this.zone.run(() => {
              this.buttonLoading = false;
                this.SpinnerService.hide();
                if (status == 200) {
                  this.StripeCardEror = '';
                  const stripe_token = response.id ;
                  const card_id = response.card.id;
                  this.UserService.addUserCard(card_id,stripe_token,"","1").subscribe((result)=>{
                    if (result.status == 1) {
                      this.StripeCardEror = result.msg;
                      this.userCards();
                      setTimeout(() => {
                        //this.ngOnInit();
                        this.StripeCardEror = '';
                        const close_card_mdl_add = document.querySelector('.close_card_mdl_add');
                        if (close_card_mdl_add instanceof HTMLElement) {
                          close_card_mdl_add.click();
                        }

                        const open_credit_modal = document.querySelector('.open_credit_modal');
                        if (open_credit_modal instanceof HTMLElement) {
                        open_credit_modal.click();
                        }
                        this.add_card_form.get('number').setValue("");
                        this.add_card_form.get('exp_month').setValue("");
                        this.add_card_form.get('exp_year').setValue("");
                        this.add_card_form.get('cvv').setValue("");
                        this.add_card_submitted = false;
                      }, 1000);
                    }
                    else{
                      this.StripeCardEror = result.validationErrors.card;
                    }
                  });
                }else {
                    this.StripeCardEror = response.error.message;
                }
            });
        });
       
      }
}